import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
import { EventEmitter } from '@angular/core';
import { CartService } from 'src/app/services/cart/cart.service';
import { Subscription } from 'rxjs';
import { Storage } from '@ionic/storage';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-header-test',
    templateUrl: './header-test.component.html',
    styleUrls: ['./header-test.component.scss'],
})
export class HeaderTestComponent implements OnInit {
    @Input() region: any;
    @Output() openRegionModalEvent = new EventEmitter();
    @Input() stickyHeader: boolean;
    @Output() getStickyHeight = new EventEmitter();
    data = {};
    cartLength = 0;
    cartTotalPrice: number = 0;
    cartSub: Subscription;
    loginStatus = false;

    dumyheaderData = {
        headerStyle: "header-one",
        logo: {
            src: "",
            width: "",
            height: ""
        },
        notificationBar: {
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
            color: {
                backgroundColor: "red",
                foregroundColor: "#000"
            },
            show: true
        },
        infoBar: {
            leftText: "Info bar left text",
            rightText: "Info bar righttext",
            color: {
                backgroundColor: "red",
                foregroundColor: "#000"
            },
            show: true

        },
        loginButton: {
            show: true,
            text: "Login",
            color: {
                backgroundColor: "red",
                foregroundColor: "#000"
            },
            userMenu: [
                {
                    title: "Atta & Flour",
                    link: "/shop/category/atta-%2526-flour/v8VLnM0rLyPznbnGqIy7"
                },
            ]
        },
        wishlistButton: {
            show: true,
            text: "wishlist",
            color: ""
        },
        cartButton: {
            show: true,
            text: "My Cart",
            color: ""
        },
        search: {
            show: true,
            placholderText: "search ...",
        },
        menuData: {
            show: true,
            menuItems: [
                {
                    title: "Home",
                    link: "/"
                },
                {
                    title: "Rice & Rice Products",
                    link: "/shop/category/rice-%2526-rice-products/5UD5K6cGM0mbFh2L9vyn"
                },
                {
                    title: "Atta & Flour",
                    link: "/shop/category/atta-%2526-flour/v8VLnM0rLyPznbnGqIy7"
                },
                {
                    title: "Rice & Rice Products",
                    link: "/shop/category/rice-%2526-rice-products/5UD5K6cGM0mbFh2L9vyn"
                },
                {
                    title: "Atta & Flour",
                    link: "/shop/category/atta-%2526-flour/v8VLnM0rLyPznbnGqIy7"
                },
                
                {
                    title: "Shop by catg",
                    link: "#",
                    dropdownMenu: true,
                    dropdownMenuData: [
                        {
                            title: "Rice & Rice Products",
                            link: "/shop/category/rice-%2526-rice-products/5UD5K6cGM0mbFh2L9vyn"
                        },
                        {
                            title: "Atta & Flour",
                            link: "/shop/category/atta-%2526-flour/v8VLnM0rLyPznbnGqIy7"
                        },
                        {
                            title: "Dals & Pulse",
                            link: "/shop/category/dals-%2526-pulse/DdqoN5Aac2jk4gUROvZm",
                            subMenu: true,
                            subMenuData: [
                                {
                                    title: "Rice & Rice Products",
                                    link: "/shop/category/rice-%2526-rice-products/5UD5K6cGM0mbFh2L9vyn"
                                },
                                {
                                    title: "Atta & Flour",
                                    link: "/shop/category/atta-%2526-flour/v8VLnM0rLyPznbnGqIy7"
                                },
                            ]

                        }
                    ]
                }
            ]
        }
    }

    headerData;

    constructor(
        private designStudioService: DesignStudioService,
        private cartService: CartService,
        private storage: Storage,
        private configService: ConfigService,
        public userService: UserService,
    ) { }

    async ngOnInit() {
        console.log('type', this.data);
        this.headerData = await this.designStudioService.getHeaderData();
        console.log('headerData', this.headerData)
        const cartProducts = this.cartService.getCartProducts();
        console.log('cartProducts', cartProducts);
        this.data['cartLength'] = cartProducts.length;
        this.data['cartTotalPrice'] = this.cartService.getCartPrice(cartProducts);

        this.data['priceForRetail'] = this.configService.environment.priceForRetail;
        this.data['currencyCode'] = this.configService.environment.currencyCode;
        this.data['RFQFeature'] = this.configService.environment.RFQFeature;
        this.data['role'] = await this.storage.get('userRole');
        this.initializeSubscriptions();

    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }

    async initializeSubscriptions() {
        this.cartSub = this.cartService.getCartProductsListener().subscribe((cartProducts) => {
            this.data['cartLength'] = cartProducts.length;
            this.data['cartTotalPrice'] = this.cartService.getCartPrice(cartProducts);
        });
    }

    setHeader() {
        this.designStudioService.setHeaderData(this.dumyheaderData)
    }

    openRegionModal(type) {
        this.openRegionModalEvent.emit(type);
    }

    removeSubscriptions() {
        this.cartSub.unsubscribe();
    }
}